import {
    Home,
    Newspaper,
    Building,
    Layers,
    File,
    FileText,
    FileCheck,
    FileMinus,
    FilePlus,
    FileX,
    Folder,
    FolderOpen,
    FolderPlus,
    FolderMinus,
    FolderCheck,
    Database,
    Settings,
    Settings2,
    Sliders,
    SlidersHorizontal,
    Bell,
    BellDot,
    BellOff,
    BellRing,
    Users,
    User,
    User2,
    UserCheck,
    UserPlus,
    UserMinus,
    UserX,
    UserCircle,
    Shield,
    ShieldCheck,
    ShieldX,
    Lock,
    LockOpen,
    Key,
    ChartBar,
    BarChart2,
    BarChart3,
    BarChart4,
    LineChart,
    PieChart,
    AreaChart,
    Calendar,
    CalendarCheck,
    CalendarClock,
    CalendarX,
    Clock,
    Timer,
    AlarmClock,
    Mail,
    MailCheck,
    MailX,
    MessageSquare,
    MessageCircle,
    MessagesSquare,
    Inbox,
    Send,
    SendHorizontal,
    Zap,
    Link,
    Link2,
    ExternalLink,
    Hash,
    AtSign,
    Phone,
    Smartphone,
    Tablet,
    Monitor,
    Laptop,
    Tv,
    Tv2,
    Wifi,
    WifiOff,
    Bluetooth,
    Battery,
    BatteryCharging,
    BatteryFull,
    BatteryLow,
    BatteryMedium,
    BatteryWarning,
    Sun,
    Moon,
    Cloud,
    CloudRain,
    CloudSnow,
    CloudSun,
    Cloudy,
    Droplet,
    Flame,
    Wind,
    Umbrella,
    Map,
    MapPin,
    MapPinned,
    Locate,
    LocateFixed,
    Compass,
    Navigation,
    Navigation2,
    Pin,
    PinOff,
    Flag,
    FlagOff,
    Tag,
    Tags,
    Bookmark,
    BookmarkCheck,
    BookmarkX,
    Star,
    StarHalf,
    StarOff,
    Heart,
    HeartCrack,
    HeartOff,
    HeartPulse,
    ThumbsUp,
    ThumbsDown,
    Smile,
    Frown,
    Meh,
    Laugh,
    Circle,
    Square,
    Triangle,
    Hexagon,
    Octagon,
    Diamond,
    CircleCheck,
    CircleX,
    CircleAlert,
    CircleHelp,
    CirclePlus,
    CircleMinus,
    SquareCheck,
    SquareX,
    SquarePlus,
    SquareMinus,
    Check,
    X as XIcon,
    Plus,
    Minus,
    Search as SearchIcon,
    Filter,
    SortAsc,
    SortDesc,
    ArrowUp,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ChevronUp,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsUp,
    ChevronsDown,
    ChevronsLeft,
    ChevronsRight,
    Move,
    MoveVertical,
    MoveHorizontal,
    RotateCcw,
    RotateCw,
    Undo,
    Redo,
    Copy,
    Scissors,
    Clipboard,
    ClipboardCheck,
    ClipboardList,
    ClipboardX,
    Trash,
    Trash2,
    Archive,
    ArchiveRestore,
    Download,
    Upload,
    LogOut,
    LogIn,
    Power,
    PowerOff,
    HelpCircle,
    Info,
    AlertCircle,
    AlertTriangle,
    AlertOctagon,
    CircleSlash,
    CircleSlash2,
    Slash,
    Eye,
    EyeOff,
    View,
    Image,
    ImageOff,
    Camera,
    CameraOff,
    Video,
    VideoOff,
    Mic,
    MicOff,
    Volume,
    Volume1,
    Volume2,
    VolumeX,
    Headphones,
    Music,
    Play,
    Pause,
    SkipBack,
    SkipForward,
    Rewind,
    FastForward,
    Repeat,
    Shuffle,
    Layout,
    LayoutDashboard,
    LayoutGrid,
    LayoutList,
    Grid2X2,
    Grid3X3,
    Columns,
    Rows,
    Rows2,
    Rows3,
    Rows4,
    PanelLeft,
    PanelRight,
    PanelTop,
    PanelBottom,
    Sidebar,
    SidebarClose,
    SidebarOpen,
    Menu,
    MoreHorizontal,
    MoreVertical,
    Ellipsis,
    EllipsisVertical,
    List,
    ListOrdered,
    ListTodo,
    ListChecks,
    ListX,
    ListFilter,
    ListPlus,
    ListMinus,
    ListRestart,
    ListCollapse,
    ListTree,
    Book,
    BookOpen,
    Library,
    Notebook,
    Pen,
    Pencil,
    Edit,
    Edit2,
    Edit3,
    PenLine,
    PenSquare,
    Text,
    Type,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    Code2,
    Quote,
    Pilcrow,
    Heading,
    Heading1,
    Heading2,
    Heading6,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    Link2 as LinkIcon2,
    Hash as HashIcon,
    AtSign as AtSignIcon,

    // 💰 Ícones financeiros — adicionados aqui (sem quebrar a ordem)
    Wallet,
    Wallet2,
    PiggyBank,
    Coins,
    DollarSign,
    Euro,
    PoundSterling,
    IndianRupee,
    JapaneseYen,
    Bitcoin,
    Banknote,
    Landmark,
    Building2,
    CreditCard,
    // CreditCard2,
    Receipt,
    ReceiptText,
    ReceiptEuro,
    // ReceiptDollar,
    TrendingUp,
    TrendingDown,
    TrendingUpDown,
    Activity,
    Gauge,
    GaugeCircle,
    Goal,
    ArrowUpDown,
    ArrowUpRight,
    ArrowDownLeft,
    CheckCheck,
    CircleDollarSign,
    BadgeDollarSign,
    LockKeyhole,
    ShieldAlert,
    Calculator,
    Anvil,
    Fish,
    Scale,
    ReceiptTextIcon,
    HandCoins,
    ChartCandlestick,
    // Calculator2,
    Accessibility,
    Baby,
    FireExtinguisher,
    SolarPanel,
    ScrollText,
    StoreIcon,
    Theater,
    UtilityPole,
    GraduationCap,
    Instagram,
    Youtube,
    Facebook,
    Twitch,
    Wrench,
    Album,
    Ambulance,
    Anchor,
    Percent,
    IdCard,
} from "lucide-vue-next";
import { iconesRedesSociais } from "./iconesRedesSociais";

// ✅ Mapa de ícones — atualizado com todos os financeiros
export const iconMap = {
    ...iconesRedesSociais,
    Twitch,
    IdCard,
    Anchor,
    Percent,
    Ambulance,
    Wrench,
    Album,
    Instagram,
    Youtube,
    Facebook,
    Theater,
    GraduationCap,
    UtilityPole,
    StoreIcon,
    ScrollText,
    SolarPanel,
    FireExtinguisher,
    Baby,
    Accessibility,
    ChartCandlestick,
    Fish,
    HandCoins,
    ReceiptTextIcon,
    Scale,
    Anvil,
    Home,
    Newspaper,
    Building,
    Layers,
    File,
    FileText,
    FileCheck,
    FileMinus,
    FilePlus,
    FileX,
    Folder,
    FolderOpen,
    FolderPlus,
    FolderMinus,
    FolderCheck,
    Database,
    Settings,
    Settings2,
    Sliders,
    SlidersHorizontal,
    Bell,
    BellDot,
    BellOff,
    BellRing,
    Users,
    User,
    User2,
    UserCheck,
    UserPlus,
    UserMinus,
    UserX,
    UserCircle,
    Shield,
    ShieldCheck,
    ShieldX,
    Lock,
    LockOpen,
    Key,
    ChartBar,
    BarChart2,
    BarChart3,
    BarChart4,
    LineChart,
    PieChart,
    AreaChart,
    Calendar,
    CalendarCheck,
    CalendarClock,
    CalendarX,
    Clock,
    Timer,
    AlarmClock,
    Mail,
    MailCheck,
    MailX,
    MessageSquare,
    MessageCircle,
    MessagesSquare,
    Inbox,
    Send,
    SendHorizontal,
    Zap,
    Link,
    Link2,
    ExternalLink,
    Hash,
    AtSign,
    Phone,
    Smartphone,
    Tablet,
    Monitor,
    Laptop,
    Tv,
    Tv2,
    Wifi,
    WifiOff,
    Bluetooth,
    Battery,
    BatteryCharging,
    BatteryFull,
    BatteryLow,
    BatteryMedium,
    BatteryWarning,
    Sun,
    Moon,
    Cloud,
    CloudRain,
    CloudSnow,
    CloudSun,
    Cloudy,
    Droplet,
    Flame,
    Wind,
    Umbrella,
    Map,
    MapPin,
    MapPinned,
    Locate,
    LocateFixed,
    Compass,
    Navigation,
    Navigation2,
    Pin,
    PinOff,
    Flag,
    FlagOff,
    Tag,
    Tags,
    Bookmark,
    BookmarkCheck,
    BookmarkX,
    Star,
    StarHalf,
    StarOff,
    Heart,
    HeartCrack,
    HeartOff,
    HeartPulse,
    ThumbsUp,
    ThumbsDown,
    Smile,
    Frown,
    Meh,
    Laugh,
    Circle,
    Square,
    Triangle,
    Hexagon,
    Octagon,
    Diamond,
    CircleCheck,
    CircleX,
    CircleAlert,
    CircleHelp,
    CirclePlus,
    CircleMinus,
    SquareCheck,
    SquareX,
    SquarePlus,
    SquareMinus,
    Check,
    X: XIcon,
    Plus,
    Minus,
    Search: SearchIcon,
    Filter,
    SortAsc,
    SortDesc,
    ArrowUp,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ChevronUp,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsUp,
    ChevronsDown,
    ChevronsLeft,
    ChevronsRight,
    Move,
    MoveVertical,
    MoveHorizontal,
    RotateCcw,
    RotateCw,
    Undo,
    Redo,
    Copy,
    Scissors,
    Clipboard,
    ClipboardCheck,
    ClipboardList,
    ClipboardX,
    Trash,
    Trash2,
    Archive,
    ArchiveRestore,
    Download,
    Upload,
    LogOut,
    LogIn,
    Power,
    PowerOff,
    HelpCircle,
    Info,
    AlertCircle,
    AlertTriangle,
    AlertOctagon,
    CircleSlash,
    CircleSlash2,
    Slash,
    Eye,
    EyeOff,
    View,
    Image,
    ImageOff,
    Camera,
    CameraOff,
    Video,
    VideoOff,
    Mic,
    MicOff,
    Volume,
    Volume1,
    Volume2,
    VolumeX,
    Headphones,
    Music,
    Play,
    Pause,
    SkipBack,
    SkipForward,
    Rewind,
    FastForward,
    Repeat,
    Shuffle,
    Layout,
    LayoutDashboard,
    LayoutGrid,
    LayoutList,
    Grid2X2,
    Grid3X3,
    Columns,
    Rows,
    Rows2,
    Rows3,
    Rows4,
    PanelLeft,
    PanelRight,
    PanelTop,
    PanelBottom,
    Sidebar,
    SidebarClose,
    SidebarOpen,
    Menu,
    MoreHorizontal,
    MoreVertical,
    Ellipsis,
    EllipsisVertical,
    List,
    ListOrdered,
    ListTodo,
    ListChecks,
    ListX,
    ListFilter,
    ListPlus,
    ListMinus,
    ListRestart,
    ListCollapse,
    ListTree,
    Book,
    BookOpen,
    Library,
    Notebook,
    Pen,
    Pencil,
    Edit,
    Edit2,
    Edit3,
    PenLine,
    PenSquare,
    Text,
    Type,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    Code2,
    Quote,
    Pilcrow,
    Heading,
    Heading1,
    Heading2,
    Heading6,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    LinkIcon2,
    HashIcon,
    AtSignIcon,

    // 💰 Ícones financeiros — adicionados ao mapa
    Wallet,
    Wallet2,
    PiggyBank,
    Coins,
    DollarSign,
    Euro,
    PoundSterling,
    IndianRupee,
    JapaneseYen,
    Bitcoin,
    Banknote,
    Landmark,
    Building2,
    CreditCard,
    // CreditCard2,
    Receipt,
    ReceiptText,
    ReceiptEuro,
    // ReceiptDollar,
    TrendingUp,
    TrendingDown,
    TrendingUpDown,
    Activity,
    Gauge,
    GaugeCircle,
    Goal,
    ArrowUpDown,
    ArrowUpRight,
    ArrowDownLeft,
    CheckCheck,
    CircleDollarSign,
    BadgeDollarSign,
    LockKeyhole,
    ShieldAlert,
    Calculator,
    // Calculator2,
};

// ✅ Export default para uso direto em componentes
export default iconMap;
